
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
import { getStatPileKvs } from "@/api/api-operation-service";
@Component
export default class SelectPile extends Vue {
  @Prop({ default: 200 }) private width!: number;
  @Prop({ default: "" }) private staPkId!: number | string;
  @Watch("staPkId")
  getVisible() {
    this.getStation();
  }
  @Watch("pileId")
  getValue() {
    if (this.pilePkId != this.pileId) {
      this.pilePkId = this.pileId;
    }
  }
  @Model("value", { type: String }) private pileId!: string;
  private stationList: object[] = [];

  private pilePkId = "";

  async getStation(): Promise<void> {
    if (this.staPkId == "") {
      this.stationList = [];
      this.pilePkId = "";
    } else {
      const ret = await getStatPileKvs({ staPkId: this.staPkId, valueType: 1 });
      if (ret.status === this.$config.apiStatus) {
        this.stationList = ret.data;
      }
    }
  }

  public selectStation(val: string): void {
    val = val == undefined ? "" : val;
    this.pilePkId = val;
    this.$emit("value", val);
    this.$emit("change", val);
  }
  mounted() {
    this.pilePkId = this.pileId;
    if (this.staPkId != "") {
      this.getStation();
    }
  }
}
